import { Address } from '@aloft/toolkit-shared';
import { Block, Flex, Grid, IconButton, Input } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { Input as ChakraInput } from '@aloft/toolkit-sui/chakra';

import { Controller, useFormContext } from 'react-hook-form';

import { useGoogleMapsLoader } from '../../hooks/googleMaps/useGoogleMapsLoader.ts';

export const AddressInput = ({
  addressLabel,
  lockAddress,
  isRequired = true,
  index,
  onRemove,
}: {
  addressLabel?: string;
  lockAddress?: boolean;
  isRequired?: boolean;
  index?: number;
  onRemove?: (index: number) => void;
}) => {
  const mapsLoader = useGoogleMapsLoader();
  const { control, setValue, trigger } = useFormContext();

  const fieldName = index === undefined ? 'address' : `addresses.${index}`;

  const handlePlaceChange = (address: Address) => {
    setValue(fieldName, address);
    // Revalidate
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    trigger();
  };

  return (
    <Flex width="100%" gap={3} flexDirection="column">
      <Grid gridTemplateColumns="3fr 1fr 1.4fr" gap={2} alignItems="end" position="relative">
        <Block __dangerDoNotUseSx={{ gridColumn: 'span 2 / span 2' }}>
          {index !== undefined && index > 0 && (
            <IconButton
              size="sm"
              variant="tertiary"
              __dangerDoNotUseSx={{ position: 'absolute', right: '0' }}
              icon="delete-bin"
              ariaLabel="Remove address"
              onClick={() => onRemove?.(index)}
            />
          )}

          <Controller
            name={`${fieldName}.AddressLineText`}
            control={control}
            render={({ field, fieldState }) => (
              <Input
                {...field}
                isRequired={isRequired}
                label={addressLabel || 'Comp Address'}
                type="locationAddressAutocomplete"
                mapsLoader={mapsLoader}
                onClear={() => field.onChange('')}
                isInvalid={fieldState.invalid}
                onPlaceChanged={handlePlaceChange}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name={`${fieldName}.unitNumber`}
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="Suite/Apt #"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name={`${fieldName}.CityName`}
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="City"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name={`${fieldName}.StateCode`}
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="State"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name={`${fieldName}.PostalCode`}
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="Zip"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
      </Grid>
    </Flex>
  );
};
